import CustomerDatabase from './CustomerDatabase'

export default CustomerDatabase
